<template>
  <div class="selectaddinvoice">
    <re-dialog :title="type=='add'?'新增发票':'修改发票'" :visible.sync="visible" width="600px">
      <div slot="title">
        <div class="nav">注意：请认真填写发票内容，若因个人填写错误造成的损失，本平台概不负责！</div>
      </div>

      <el-form ref="form" :model="form" label-width="80px" style="width:100%" :rules="rules2">
        <el-form-item label="发票类型:">
          <template>
            <el-radio v-model="form.invoice_type" label="1">普通发票</el-radio>
            <el-radio v-model="form.invoice_type" label="2">专用发票</el-radio>
          </template>
        </el-form-item>
        <el-form-item label="发票抬头:" prop="invoice_name">
          <el-input v-model="form.invoice_name" clearable size="mini" style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码:" prop="invoice_taxno">
          <el-input v-model="form.invoice_taxno" clearable size="mini" style="width:100%"></el-input>
        </el-form-item>
        <template v-if="form.invoice_type == '2'">
          <el-form-item label="注册地址:" prop="invoice_address" v-show="form.invoice_type == '2'">
            <el-input v-model="form.invoice_address" clearable size="mini" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item label="注册电话:" prop="invoice_mobile" v-show="form.invoice_type == '2'">
            <el-input v-model="form.invoice_mobile" clearable size="mini" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item label="开户银行:" prop="invoice_bank_name" v-show="form.invoice_type == '2'">
            <el-input v-model="form.invoice_bank_name" clearable size="mini" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item label="银行卡号:" prop="invoice_back_no" v-show="form.invoice_type == '2'">
            <el-input v-model="form.invoice_back_no" clearable size="mini" style="width:100%"></el-input>
          </el-form-item>
        </template>
        <el-form-item label v-if="type == 'edit' && form.is_default">
          <el-checkbox :value="form.is_default">设置为默认发票</el-checkbox>
        </el-form-item>
        <el-form-item label v-else>
          <el-checkbox v-model="form.is_default">设置为默认发票</el-checkbox>
        </el-form-item>
        <el-form-item label>
          <el-button
              type="primary"
              size="small"
              @click="onSubmit('form')"
          >{{ type == "add" ? "添加发票" : "修改发票" }}
          </el-button>
        </el-form-item>
      </el-form>
    </re-dialog>
  </div>
</template>

<script>
export default {
  props: {
    invoiceVisible: Boolean,
    type: {
      type: String,
      default: "add"
    },
    info: Object,
    company_id: String
  },
  data() {
    let that = this;
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      }
      //    else if (!that.checkPhone(value)) {
      //     return callback(new Error("手机号输入错误"));
      //   }
    };
    var checktaxno = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入统一社会信用代码"));
      }
      //    else if (!that.checkTaxId(value)) {
      //     return callback(new Error("统一社会信用代码输入错误"));
      //   }
    };
    return {
      form: {
        invoice_name: "",
        invoice_type: "1",
        invoice_address: "",
        invoice_mobile: "",
        invoice_taxno: "",
        invoice_bank_name: "",
        is_default: false,
        invoice_back_no: ""
      },
      rules: {},
      rules1: {
        invoice_name: [
          {
            required: true,
            message: "请输入发票抬头",
            trigger: "blur"
          }
        ],
        invoice_taxno: [
          {
            required: true,
            validator: checktaxno,
            trigger: "blur"
          }
        ]
      },
      rules2: {
        invoice_name: [
          {
            required: true,
            message: "请输入发票抬头",
            trigger: "blur"
          }
        ],
        invoice_mobile: [
          {
            required: true,
            validator: checkPhone,
            trigger: "blur"
          }
        ],
        invoice_taxno: [
          {
            required: true,
            validator: checktaxno,
            trigger: "blur"
          }
        ],
        invoice_address: [
          {
            required: true,
            message: "请输入注册地址",
            trigger: "blur"
          }
        ],
        invoice_bank_name: [
          {
            required: true,
            message: "请输入开户银行",
            trigger: "blur"
          }
        ],
        invoice_back_no: [
          {
            required: true,
            message: "请输入银行卡号",
            trigger: "blur"
          }
        ]
      },
      visible: this.invoiceVisible
    };
  },
  mounted() {
    this.rules = this.rules1;
  },
  watch: {
    "form.invoice_type"(n) {
      if (!this.visible) {
        return;
      }
    },
    invoiceVisible(n) {
      this.visible = n;
      if (n && this.type === 'add') {
        this.getSellCompany();
      }
    },
    visible(n) {
      this.$emit("update:invoiceVisible", n);
    },
    info: {
      deep: true,
      handler(n) {
        this.form = JSON.parse(JSON.stringify(n));
        this.form.is_default = n.is_default == "1" ? true : false;
      }
    },
    type(n) {
      if (n == "edit") {
        console.log(this.info)
        this.form = JSON.parse(JSON.stringify(this.info));
        this.form.is_default = this.info.is_default == "1" ? true : false;
      }
    },
  },
  methods: {
    onSubmit(formName) {
      let ok = true;
      this.$refs[formName].validate(valid => {
        if (!valid) {
          ok = false;
        }
      });
      if (!ok) return;
      let obj = {};
      obj.is_default = obj.is_default ? "1" : "0";
      obj.company_id = this.company_id;
      obj.invoice_name = this.form.invoice_name;
      obj.invoice_taxno = this.form.invoice_taxno;
      obj.invoice_type = this.form.invoice_type;
      if (obj.invoice_type == "2") {
        obj.invoice_address = this.form.invoice_address;
        obj.invoice_mobile = this.form.invoice_mobile;
        obj.invoice_bank_name = this.form.invoice_bank_name;
        obj.invoice_back_no = this.form.invoice_back_no;
      }
      if (this.type == "add") {
        // 增加发票
        this.post("/invoiceInterfaces/v1.0/insertInvoice", obj).then(res => {
          this.$message.success("添加成功!")
          this.$emit("cloneVisible", {
            invoice_id: res.data,
            invoice_name: this.form.invoice_name,
            invoice_type: this.form.invoice_type
          });
          this.form.invoice_name = "";
          this.form.invoice_taxno = "";
          this.form.invoice_type = "1";
          this.form.invoice_address = "";
          this.form.invoice_mobile = "";
          this.form.invoice_bank_name = "";
          this.form.is_default = false;
          this.form.invoice_back_no = "";
          this.visible = false;
        });
      } else {
        obj.invoice_id = this.form.invoice_id;
        // 修改发票
        this.post("invoiceInterfaces/v1.0/updateInvoice", obj).then(res => {
          this.$message.success("修改成功!")
          this.$emit("cloneVisible", JSON.parse(JSON.stringify(this.form)));
          this.form.invoice_name = "";
          this.form.invoice_type = "1";
          this.form.invoice_address = "";
          this.form.invoice_mobile = "";
          this.form.invoice_taxno = "";
          this.form.invoice_bank_name = "";
          this.form.is_default = false;
          this.form.invoice_back_no = "";
          this.visible = false;
        });
      }
    },
    // 获取客户详情,用于填充发票信息.
    getSellCompany() {
      this.post("memberInterfaces/v1.0/getSellCompany", {company_id: this.company_id}).then(res => {
        this.form.invoice_name = res.data.company_name;
        this.form.invoice_taxno = res.data.company_taxno;
        this.form.invoice_address =
            res.data.company_province +
            "" +
            res.data.company_city +
            "" +
            res.data.company_country +
            "" +
            res.data.company_address;
        this.form.invoice_mobile = res.data.company_tel;
        this.form.invoice_bank_name = res.data.company_bank_name;
        this.form.invoice_back_no = res.data.company_bank_no;
      });
    }
  }
};
</script>

<style lang="scss">
.selectaddinvoice {
  .address_title {
    width: 10%;
  }

  .el-dialog {
    .el-dialog__header {
      height: 70px;

      .head {
        padding: 0 20px;
        background-color: #eaeaea;
        height: 40px;
      }

      .nav {
        height: 30px;
        background-color: #faad00;
        font-size: 12px;
        padding: 0 40px;
        color: #fa0000;
        line-height: 30px;
      }
    }

    .el-dialog__body {
      display: flex;
      justify-content: center;
      padding: 20px 30px;

      .el-form {
        width: 80%;

        .el-form-item {
          margin-bottom: 10px;

          .el-form-item__label {
            width: 140px !important;
          }

          .el-form-item__content {
            margin-left: 140px !important;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AddInvoice.vue